import { getDeviceType } from '@superbet-group/web.lib.vue-utilities';

enum DeviceType {
    desktop = 'desktop',
    tablet = 'tablet',
    mobile = 'mobile',
}

const detectDeviceType = (type?: string) => {
    switch (type) {
        case 'console':
        case 'mobile':
        case 'wearable':
        case 'embedded':
            return DeviceType.mobile;
        case 'tablet':
            return DeviceType.tablet;
        case 'smarttv':
            return DeviceType.desktop;
        // device type is undefined for desktops (tested on sample size of 1)
        default:
            return DeviceType.desktop;
    }
};

export const deviceType = detectDeviceType(getDeviceType());

export const isMobileDevice = deviceType === DeviceType.mobile;
export const isTabletDevice = deviceType === DeviceType.tablet;
export const isDesktopDevice = deviceType === DeviceType.desktop;
